import {Injectable} from '@angular/core';
import {AbstractControl, ValidatorFn} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {FileSizePipe} from 'app/pipes/file-size.pipe';


@Injectable({
    providedIn: 'root'
})
export class FilesValidatorsService {

    constructor(private translocoService: TranslocoService, private FileSizePipe: FileSizePipe) {
    }

    maxFileSizeValidator(maxFileSize: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: { maxSize: number, message: string } } | null => {
            if (maxFileSize && control.value instanceof File) {
                const maxSizeAsString = this.FileSizePipe.transform(maxFileSize);
                return control.value.size > maxFileSize ? {
                    maxSize: {
                        maxSize: maxFileSize,
                        message: this.translocoService.translate('Max file size validation error (upload files) - Maximum file size exceeded', {maxSize: maxSizeAsString})
                    }
                } : null;
            } else {
                return null;
            }
        };
    }

    fileTypeValidator(fileTypes: string[]): ValidatorFn {
        return (control: AbstractControl): { [key: string]: string } | null => {
            if (fileTypes?.length > 0 && control.value instanceof File) {
                return fileTypes?.some(x => x === control.value.type) ? null : {
                    unsupportedFileType: this.translocoService.translate('Unsupported file type validation error (upload files) - Unsupported file type')
                };
            } else {
                return null;
            }
        };

    }
}
